import { format } from 'date-fns';
import { comma, mis2Msms, bytes, kilobytes, megabytes, ms2Msms, s2Hms } from '../utils/formatter';
//Process -> Queue 탭에 WP Type을 숫자 형식에서 문자로 변경 0 -> NOWP
import { WP_TYPE_QUEUE_BY_NUM } from '../constants';

export default {
  install(Vue) {
    Vue.filter('format', (value, pattern) => {
      return value ? format(value, pattern) : '';
    });

    Vue.filter('comma', (value, ignoreZero = false) => {
      return comma(value, ignoreZero);
    });

    Vue.filter('millis', value => {
      return value ? Math.round(value / 1000) : '';
    });

    Vue.filter('concat', (value, str) => {
      return value === 0 || value ? String(value) + str : str;
    });

    // value: seconds 기준
    Vue.filter('readable', (value, displayZero) => {
      if (value) {
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const seconds = (value % 3600) % 60;
        return `${hours > 0 ? hours + ' h ' : ''}${minutes > 0 ? minutes + ' m ' : ''}${seconds > 0 ? seconds + ' s' : ''}`;
      } else if (displayZero) {
        return '< 0 s';
      }
      return '';
    });

    Vue.filter('mis2Msms', value => {
      return mis2Msms(value);
    });

    Vue.filter('bytes', (value, devider) => {
      return bytes(value, devider);
    });

    Vue.filter('kilobytes', (value, devider) => {
      return kilobytes(value, devider);
    });

    Vue.filter('megabytes', (value, devider) => {
      return megabytes(value, devider);
    });

    Vue.filter('ms2Msms', value => {
      return ms2Msms(value);
    });

    Vue.filter('s2Hms', value => {
      return s2Hms(value);
    });

    //Process -> Queue 탭에 WP Type을 숫자 형식에서 문자로 변경 1 -> DIA
    Vue.filter('wpTypeQueue', value => {
      const map = WP_TYPE_QUEUE_BY_NUM();
      const key = String(value);
      if (key in map) return map[key];
      return value != null ? key : '';
    });
  },
};
